import classNames from 'classnames';

export const getWrapperClassNames = (
    isCssVariationMobile,
    isHotelsVisibility,
) =>
    classNames({
        'odf-space-inner-left-m odf-space-inner-right-m': !isCssVariationMobile,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
        'odf-position-relative odf-bg-base': true,
        'odf-space-inner-top-m  odf-space-inner-bottom-m': true,
        'od-flights-manager-wrapper': isHotelsVisibility,
    });

export const getTripTypeWrapperClassNames = (isCssVariationMobile) =>
    classNames({
        'odf-space-outer-bottom-m': !isCssVariationMobile,
        'odf-space-outer-top-s odf-space-outer-bottom-l': isCssVariationMobile,
    });

export const getButtonWrapperClassNames = (isCssVariationMobile, airlineIata, airlineName) =>
    classNames({
        'odf-space-outer-top-m': !isCssVariationMobile || (airlineIata && airlineName),
        'odf-space-outer-top-2xl': isCssVariationMobile && !(airlineIata && airlineName),
    });

export const getSecondaryButtonClassNames = (isCssVariationMobile) =>
    classNames({
        'odf-space-outer-top-s': !isCssVariationMobile,
        'odf-space-outer-top-m': isCssVariationMobile,
    });

export const getFlightsManagerClassNames = () =>
    classNames({
        'odf-text-left od-mobile-manager-default': true,
    });
